module.exports = __webpack_public_path__ + "img/1484696293.23e25180.jpg";